import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContenedorCaidoLoadingComponent } from './contenedor-caido-loading.component';
import {SharedModule} from "../shared.module";
import {LottieComponent} from "ngx-lottie";
import {FormSharedModule} from '../form-shared.module';

@NgModule({
    declarations: [ContenedorCaidoLoadingComponent],
  imports: [
    CommonModule,
    SharedModule,
    LottieComponent,
    FormSharedModule
  ],
    providers: [ContenedorCaidoLoadingComponent],
    exports: [ContenedorCaidoLoadingComponent]
})
export class ContenedorCaidoLoadingModule { }
